// import "./InputOptions.css";

export default function InputOptions(props) {
  const { className, options, onOptionSelected } = props;
  return (
    <div className={`input-options ${className || ""}`}>
      <div className="input-options-wrapper">
        {options.map((option, index) => (
          <div
            key={index}
            className="input-option"
            onClick={() => onOptionSelected(index, option.text)}
          >
            <div className="input-option-text valign-text-middle roobertvrt-regular-normal-midnight-18px">
              {option.text}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
